// extracted by mini-css-extract-plugin
module.exports = {"title":"Panelists_title__12bV4","headers":"Panelists_headers__3Jyl-"};